import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { Transition } from '@headlessui/react';
import { RemoveScroll } from 'react-remove-scroll';
import useOnEsc from 'hooks/useOnEsc';
import useTrapFocus from 'hooks/useTrapFocus';
import useRandomId from 'hooks/useRandomId';
import getOrCreateElementById from 'commons/getOrCreateElementById';
import MobileModal from 'components/consumer/MobileModal';
import MoveItButton from 'components/consumer/MoveItButton';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import useFocusOnOpen from 'hooks/useFocusOnOpen';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import useScreen from 'hooks/useScreen';
const sidebarModalRootElement = getOrCreateElementById('SidebarModal-root');
const SidebarModal = t0 => {
  const $ = _c(56);
  const {
    children,
    isOpen: t1,
    lockScrollWhenOpen: t2,
    mobileCloseIcon,
    mobileContent,
    mobileContentUnderHeader: t3,
    mobileHeaderCenter,
    mobileHeaderRight,
    mobileIsFullHeight: t4,
    mobileNoPadding: t5,
    mobileScrollingHeader,
    mobileStickyFooter,
    mobileHideHeader,
    desktopNoCloseIcon: t6,
    desktopNoPadding: t7,
    desktopNoScroll: t8,
    desktopWidthSize,
    onClose,
    title,
    transparentOverlay: t9
  } = t0;
  const isOpen = t1 === undefined ? false : t1;
  const lockScrollWhenOpen = t2 === undefined ? true : t2;
  const mobileContentUnderHeader = t3 === undefined ? null : t3;
  const mobileIsFullHeight = t4 === undefined ? false : t4;
  const mobileNoPadding = t5 === undefined ? false : t5;
  const desktopNoCloseIcon = t6 === undefined ? false : t6;
  const desktopNoPadding = t7 === undefined ? false : t7;
  const desktopNoScroll = t8 === undefined ? false : t8;
  const transparentOverlay = t9 === undefined ? false : t9;
  const {
    isMobile
  } = useScreen();
  const modalRef = useFocusOnOpen(isOpen);
  const modalTitleId = useRandomId("SidebarModal-title");
  useOnEsc(isOpen, onClose);
  useTrapFocus(isOpen, modalRef);
  if (isMobile) {
    const t10 = mobileContent || children;
    const t11 = mobileContentUnderHeader || mobileNoPadding;
    let t12;
    if ($[0] !== isOpen || $[1] !== lockScrollWhenOpen || $[2] !== mobileCloseIcon || $[3] !== mobileContentUnderHeader || $[4] !== mobileHeaderCenter || $[5] !== mobileHeaderRight || $[6] !== mobileHideHeader || $[7] !== mobileIsFullHeight || $[8] !== mobileScrollingHeader || $[9] !== mobileStickyFooter || $[10] !== onClose || $[11] !== t10 || $[12] !== t11 || $[13] !== title) {
      t12 = <MobileModal {...{
        children: t10,
        closeIcon: mobileCloseIcon,
        contentUnderHeader: mobileContentUnderHeader,
        headerCenter: mobileHeaderCenter,
        headerRight: mobileHeaderRight,
        hideHeader: mobileHideHeader,
        isFullHeight: mobileIsFullHeight,
        isOpen,
        lockScrollWhenOpen,
        noPadding: t11,
        onClose,
        scrollingHeader: mobileScrollingHeader,
        stickyFooter: mobileStickyFooter,
        title
      }} />;
      $[0] = isOpen;
      $[1] = lockScrollWhenOpen;
      $[2] = mobileCloseIcon;
      $[3] = mobileContentUnderHeader;
      $[4] = mobileHeaderCenter;
      $[5] = mobileHeaderRight;
      $[6] = mobileHideHeader;
      $[7] = mobileIsFullHeight;
      $[8] = mobileScrollingHeader;
      $[9] = mobileStickyFooter;
      $[10] = onClose;
      $[11] = t10;
      $[12] = t11;
      $[13] = title;
      $[14] = t12;
    } else {
      t12 = $[14];
    }
    return t12;
  }
  let t10;
  if ($[15] !== transparentOverlay) {
    t10 = classNames("fixed bottom-0 top-0 left-0 right-0 bg-blackOverlay group-[:not(:first-child)]:![background:none]", {
      "![background:none]": transparentOverlay
    });
    $[15] = transparentOverlay;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== onClose || $[18] !== t10) {
    t11 = <Transition.Child aria-hidden={true} className={t10} onClick={onClose} tabIndex="-1" appear="true" unmount={true} enter="transition-opacity duration-500 ease-in-out" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity duration-500 ease-in-out" leaveFrom="opacity-100" leaveTo="opacity-0" />;
    $[17] = onClose;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== transparentOverlay) {
    t12 = classNames("bg-gray-light9 cursor-default h-screen fixed right-0 top-0", {
      "border-l-2 border-solid border-gray-light7": transparentOverlay
    });
    $[20] = transparentOverlay;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const t13 = !desktopNoPadding;
  const t14 = !desktopNoScroll;
  const t15 = desktopWidthSize !== "lg";
  const t16 = desktopWidthSize === "lg";
  let t17;
  if ($[22] !== desktopNoPadding || $[23] !== desktopNoScroll || $[24] !== t13 || $[25] !== t14 || $[26] !== t15 || $[27] !== t16) {
    t17 = classNames("h-screen overflow-x-hidden", {
      "pt-[4.5rem] px-8 pb-8": t13,
      "p-0": desktopNoPadding,
      "overflow-y-auto": t14,
      "bg-white": desktopNoScroll,
      "w-[448px]": t15,
      "w-[600px]": t16
    });
    $[22] = desktopNoPadding;
    $[23] = desktopNoScroll;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <VisuallyHidden>Dialog content starts</VisuallyHidden>;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== desktopNoCloseIcon || $[31] !== onClose) {
    t19 = !desktopNoCloseIcon && <MoveItButton className="absolute right-4 top-4 bg-white" onClick={onClose} />;
    $[30] = desktopNoCloseIcon;
    $[31] = onClose;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== modalTitleId || $[34] !== title) {
    t20 = title && <h2 className="text-xl font-bold text-gray mt-0 mx-0 mb-2" id={modalTitleId}>{title}</h2>;
    $[33] = modalTitleId;
    $[34] = title;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <VisuallyHidden>Dialog content ends</VisuallyHidden>;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== children || $[38] !== modalRef || $[39] !== modalTitleId || $[40] !== t19 || $[41] !== t20) {
    t22 = <div ref={modalRef} role="dialog" aria-labelledby={modalTitleId}>{t18}{t19}{t20}{children}{t21}</div>;
    $[37] = children;
    $[38] = modalRef;
    $[39] = modalTitleId;
    $[40] = t19;
    $[41] = t20;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== lockScrollWhenOpen || $[44] !== t17 || $[45] !== t22) {
    t23 = <RemoveScroll className={t17} removeScrollBar={false} enabled={lockScrollWhenOpen}>{t22}</RemoveScroll>;
    $[43] = lockScrollWhenOpen;
    $[44] = t17;
    $[45] = t22;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t12 || $[48] !== t23) {
    t24 = <Transition.Child className={t12} appear="true" unmount={true} enter="transition-[opacity,transform] duration-500 ease-in-out" enterFrom="opacity-0 translate-x-[100vw]" enterTo="translate-x-0 opacity-100" leave="transition-[opacity,transform] duration-500 ease-in-out" leaveFrom="translate-x-0 opacity-100" leaveTo="opacity-0 translate-x-[calc(100vw_-_4rem)]">{t23}</Transition.Child>;
    $[47] = t12;
    $[48] = t23;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t11 || $[51] !== t24) {
    t25 = <div className="SidebarModal">{t11}{t24}</div>;
    $[50] = t11;
    $[51] = t24;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== isOpen || $[54] !== t25) {
    t26 = createPortal(<Transition show={isOpen} unmount={true} appear={true} enter="transition-opacity duration-500 ease-in-out" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity duration-500 ease-in-out" leaveFrom="opacity-100" leaveTo="opacity-0">{t25}</Transition>, sidebarModalRootElement);
    $[53] = isOpen;
    $[54] = t25;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  return t26;
};
SidebarModal.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  lockScrollWhenOpen: PropTypes.bool,
  mobileCloseIcon: PropTypes.node,
  mobileContent: PropTypes.node,
  mobileContentUnderHeader: PropTypes.bool,
  mobileHeaderCenter: PropTypes.node,
  mobileHeaderRight: PropTypes.node,
  mobileHideHeader: PropTypes.bool,
  mobileIsFullHeight: PropTypes.bool,
  mobileNoPadding: PropTypes.bool,
  mobileScrollingHeader: PropTypes.node,
  mobileStickyFooter: PropTypes.node,
  desktopWidthSize: PropTypes.oneOf(['lg']),
  desktopNoPadding: PropTypes.bool,
  desktopNoScroll: PropTypes.bool,
  desktopNoCloseIcon: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  transparentOverlay: PropTypes.bool
};
export default withBrowserOnly(SidebarModal);